/**
 * OpenAI model pricing constants (USD per million tokens).
 * Ordered from most-specific to least-specific so substring matching
 * prefers 'gpt-4o-mini' over 'gpt-4o'.
 */
export const OPENAI_MODEL_PRICING = [
    // Dated snapshot id — list before generic `gpt-5` substring matches
    { match: 'gpt-5-2025-08-07', promptPerM: 0.625, completionPerM: 5.0 },
    { match: 'gpt-4o-mini', promptPerM: 0.15, completionPerM: 0.6 },
    { match: 'gpt-5-mini', promptPerM: 0.25, completionPerM: 2.0 },
    { match: 'gpt-5-nano', promptPerM: 0.05, completionPerM: 0.4 },
    { match: 'gpt-4o', promptPerM: 2.5, completionPerM: 10.0 },
    { match: 'gpt-4-turbo', promptPerM: 10.0, completionPerM: 30.0 },
    { match: 'gpt-4', promptPerM: 30.0, completionPerM: 60.0 },
    { match: 'gpt-3.5-turbo', promptPerM: 0.5, completionPerM: 1.5 },
    // Gemini Flash-Lite tier rates so Gemini runs are still costed in the LM run
    // log rather than defaulting to gpt-4o-mini.
    // https://ai.google.dev/gemini-api/docs/pricing
    { match: 'gemini-3.5-flash-lite', promptPerM: 0.3, completionPerM: 2.5 },
    { match: 'gemini-3.1-flash-lite', promptPerM: 0.25, completionPerM: 1.5 },
];
/** Default rates when no pricing entry matches the model name (gpt-4o-mini). */
export const OPENAI_DEFAULT_PRICING = OPENAI_MODEL_PRICING.find(p => p.match === 'gpt-4o-mini');
/**
 * Calculates the estimated cost in USD for an OpenAI LLM call.
 * Matches on a substring of the model name (case-insensitive).
 */
export function calcOpenAICostUsd(model, promptTokens, completionTokens) {
    const lower = model.toLowerCase();
    const rates = OPENAI_MODEL_PRICING.find(p => lower.includes(p.match)) ??
        OPENAI_DEFAULT_PRICING;
    return ((promptTokens / 1_000_000) * rates.promptPerM +
        (completionTokens / 1_000_000) * rates.completionPerM);
}
//# sourceMappingURL=openai-pricing.js.map